import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "cal-background-dialog" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-center nunito fw-bold fz-22 py-2 mb-3" }, "Background Style", -1);
const _hoisted_3 = { class: "d-flex flex-wrap" };
const _hoisted_4 = ["src", "onClick"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", {
    role: "button",
    class: "d-none text-decoration-underline my-2 text-primary"
}, "<<Back to Settings", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-chevron-double-left" }, null, -1);
import { useCalendarTemplatesStore } from '../stores/calendarTemplates';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BackgroundDialog',
    emits: ["closeDialog"],
    setup(__props, { emit }) {
        const calendarTemplatesStore = useCalendarTemplatesStore();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    "aria-label": "Close",
                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('closeDialog')))
                }),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(35, (i) => {
                        return _createElementVNode("img", {
                            class: _normalizeClass(["shape-control", { selected: (_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].settings.headerBackgroundImage == 'bg' + i + '.png') }]),
                            src: '/images/backgrounds/bg' + i + '.png',
                            onClick: ($event) => (_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].settings.headerBackgroundImage = 'bg' + i + '.png')
                        }, null, 10, _hoisted_4);
                    }), 64))
                ]),
                _hoisted_5,
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary btn-md mt-5 ms-2 fz-16 lh-24",
                    "aria-label": "Close",
                    onClick: _cache[1] || (_cache[1] = ($event) => (emit('closeDialog')))
                }, [
                    _hoisted_6,
                    _createTextVNode("Back to Settings ")
                ])
            ]));
        };
    }
});
